import React from 'react';
import tw, { styled } from 'twin.macro';
import PropTypes from 'prop-types';

import { Indicator as BaseIndicator } from '@sopranodesign/pulse-components';

const FatIndicator = styled(BaseIndicator)`
  ${tw`w-3 h-3 mr-2`}
`;

//import React Log level constants
const STATES = {
  WARNING: 'warning',
  SUCCESS: 'success',
  ERROR: 'error'
};

// Color mapping for log levels
const getStateColor = (state) => {
  switch (state) {
    case STATES.SUCCESS:
      return 'positive';
    case STATES.ERROR:
      return 'danger';
    case STATES.WARNING:
    default:
      return 'warning';
  }
};

const LogIndicator = ({ state }) => (
  <FatIndicator colour={getStateColor(state)} />
);

LogIndicator.propTypes = {
  state: PropTypes.string.isRequired
};

const levels = {
  [STATES.WARNING]: () => <LogIndicator state={STATES.WARNING} />,
  [STATES.SUCCESS]: () => <LogIndicator state={STATES.SUCCESS} />,
  [STATES.ERROR]: () => <LogIndicator state={STATES.ERROR} />
};

const LogLevel = ({ level }) => {
  const Indicator = levels[level] || levels[STATES.WARNING];
  return <Indicator />;
};

LogLevel.propTypes = {
  level: PropTypes.string.isRequired
};

export default LogLevel;
